import { useRef, type FC, type MouseEvent } from 'react';
import { Flex, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { shouldSuppressNavigationClick } from '~/app/components/session/ChargesTable/utils';

export interface SessionIdentifierCellProps {
  identifier: string;
  transactionId: string | null;
}

export const SessionIdentifierCell: FC<SessionIdentifierCellProps> = ({
  identifier,
  transactionId,
}) => {
  const { t } = useTranslation('sessions');
  const navigate = useNavigate();
  const pointerDownRef = useRef<{ x: number; y: number } | null>(null);

  const trimmedTransaction = transactionId?.trim() ?? '';

  const openDetails = (event: MouseEvent) => {
    event.stopPropagation();
    if (shouldSuppressNavigationClick(event, pointerDownRef.current)) {
      return;
    }
    navigate(`/sessions/${identifier}`);
  };

  return (
    <Flex vertical gap={2}>
      <Typography.Link
        style={{ userSelect: 'text' }}
        onMouseDown={(event) => {
          pointerDownRef.current = { x: event.clientX, y: event.clientY };
        }}
        onClick={openDetails}
      >
        {identifier}
      </Typography.Link>
      {trimmedTransaction ? (
        <Typography.Text
          type="secondary"
          style={{ fontSize: 12, userSelect: 'text' }}
        >
          {t('transactionNumber', { number: trimmedTransaction })}
        </Typography.Text>
      ) : null}
    </Flex>
  );
};
